@import 'styles/variables';
@import 'styles/mixins';

$mobile-left-content-height: 146px;

.content {
  &.isTabletPortrait {
    height: 100vh;
  }

  &:not(.isTabletPortrait) {
    width: 1005px;
    height: 590px;
    display: flex;

    // shift content to the right since the width in this step is wider than the previous one
    left: calc((100% - 1005px) / 2);
  }
}

.header {
  margin-bottom: 8px;
}

.container {
  &.isTabletPortrait {
    display: flex;
    flex-direction: column;

    width: 100%;
    height: 100%;
    flex-grow: 1;
    position: relative;
  }
}

.title {
  margin-bottom: 44px;

  &.isTabletPortrait {
    margin-bottom: 32px;
  }
}

.benefitsWrapper {
  text-align: left;
  color: var(--neutral-90);

  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: left;
  padding: 0px;
  gap: 16px;

  &.isTabletPortrait {
    gap: 24px;
    padding: 0 12px;
    flex: none;
    order: 1;
    flex-grow: 0;
    align-items: flex-start;
  }
}

.benefitDetail {
  @include md-regular;

  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px;
  gap: 10px;

  span {
    @include md-semibold;
  }

  &.isTabletPortrait {
    @include lg-regular;

    align-items: flex-start;
    padding: 0px;
    gap: 12px;

    flex: none;
    order: 0;
    flex-grow: 0;

    span {
      @include lg-semibold;
    }
  }
}

.iconWrapper {
  display: flex;
  flex-direction: row;
  padding: 8px 0px;
  width: 32px;

  &.isTabletPortrait {
    align-items: flex-start;
    gap: 8px;

    flex: none;
    order: 0;
    flex-grow: 0;
  }

  // as we don't have a max-width for mobile design, the emojis alignment would look  weird in the interval 792px-899px
  @media only screen and (min-width: $tabletPortraitMinWidth) and (max-width: $tabletPortraitMaxWidth) {
    padding: 0px;
  }

  svg {
    width: 32px;
    height: 32px;
  }
}

.buttonsWrapper {
  @include md-regular;

  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 16px 0px 0px;
  gap: 8px;

  position: absolute;
  width: 368px;
  height: 58px;
  bottom: 40px;

  flex: none;
  order: 1;
  flex-grow: 0;

  &.isTabletPortrait {
    @include md-regular;

    background: var(--neutral-0);

    flex-direction: column;
    justify-content: center;
    bottom: 10px;
    position: fixed;
    bottom: 0;
    left: 0;
    padding: 12px;

    width: 100%;
    margin: auto;
    height: $mobile-left-content-height;

    flex: none;
    order: 1;
    flex-grow: 0;
  }
}

.actionButton {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 4px;

  padding: 10px 16px;
  height: 44px;
  border-radius: 6px;

  flex: none;
  flex-grow: 0;

  &.isTabletPortrait {
    @include md-regular;
  }
}

.calendlyPopupButton {
  @include lg-regular;

  color: $white;
  background: var(--action-50);
  width: 100%;
  order: 0;
  align-self: stretch;
}

.reserveLater {
  @include md-regular;

  background: var(--neutral-5);
  border: 1px solid $grey-10;
  color: white;
  order: 1;
  width: 120px;

  &.isTabletPortrait {
    @include lg-regular;

    width: 100%;
    order: 1;
    align-self: stretch;
  }
}

.contactUs {
  color: var(--neutral-30);
  width: 227px;
  order: 0;

  &.isTabletPortrait {
    order: 2;
  }
}

.nextButton {
  width: 120px;
  margin-left: auto;
  order: 1;

  &.isTabletPortrait {
    width: 100%;
  }
}

.rightContent {
  text-align: center;
  background-color: var(--neutral-0);
  border-top-right-radius: 12px;
  border-bottom-right-radius: 12px;
  padding: 14px;

  .calendlyWrapper {
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 400px;

    .onboardingTitle {
      @include md-semibold;
      color: white;
      background: #563efe; // calendly blue
      border-radius: 8px 8px 0px 0px;
      box-shadow: 0px 0px 28px 0px #000000fa;
      position: relative;
      height: 54px;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    :global(.calendly-inline-widget) {
      flex-grow: 1;

      iframe {
        border-radius: 0px 0px 8px 8px;
        box-shadow: 0px 0px 28px 0px #000000fa;

        body {
          border: 1px solid red;
          @include thinScrollbar;
        }
      }
    }
  }
}

.largerLeftContent {
  &.isTabletPortrait {
    padding: 0 12px;
    height: 400px;
    flex-grow: 1;
  }
}

.leftPanel {
  @include thinScrollbar;

  &.isTabletPortrait {
    display: flex;
    flex-direction: column;

    height: 100%;
    max-height: calc(100vh - $mobile-left-content-height - 10px);
  }
}
